import { createApp } from "vue";
import store from "./store";
import App from "./App.vue";
import router from "./router";
import PrimeVue from "primevue/config";
import VueToast from "vue-toast-notification";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import "../public/assets/css/style.css";
import "../public/assets/css/fonts.css";
import "../public/assets/css/sidebars.css";
import "../public/assets/css/login.css";
import "../public/assets/css/customform.css";
import "../public/assets/css/calendar.css";
import "../public/assets/css/datatable.css";
import "../public/assets/css/modal.css"
import "vue-toast-notification/dist/theme-sugar.css";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";

import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Checkbox from "primevue/checkbox";
import InputSwitch from "primevue/inputswitch";
import Calendar from "primevue/calendar";
import Divider from "primevue/divider";
import Button from "primevue/button";
import Dropdown from "primevue/dropdown";
import FileUpload from "primevue/fileupload";
import Chart from "primevue/chart";
import OverlayPanel from "primevue/overlaypanel";
import Tree from "primevue/tree";
import OrganizationChart from "primevue/organizationchart";
import "primeicons/primeicons.css";
import VueNumberFormat from "vue-number-format";
const app = createApp(App).use(router);
app.component("Multiselect", Multiselect);
app.component("Chart", Chart);
app.component("DataTable", DataTable);
app.component("Button", Button);
app.component("Column", Column);
app.component("Toast", VueToast);
app.component("Dropdown", Dropdown);
app.component("Checkbox", Checkbox);
app.component("InputSwitch", InputSwitch);
app.component("Calendar", Calendar);
app.component("Divider", Divider);
app.component("FileUpload", FileUpload);
app.component("OverlayPanel", OverlayPanel);
app.component("Tree", Tree);
app.component("OrganizationChart", OrganizationChart);

app.use(router);
app.use(PrimeVue);
app.use(VueNumberFormat);
app.use(VueToast);
app.use(store);
app.mount("#app");
app.config.devtools = true;

app.config.errorHandler = (err, vm, info) => {
  console.error("Error:", err);
  console.error("Vue component:", vm);
  console.error("Additional info:", info);
};
